module.exports = ".logOutStyle\n{\n    color:red;\n}\n.logOutStyle:hover\n{\n    text-decoration: underline;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/template/password-viewer/password-viewer.component.css
// module id = ./src/app/template/password-viewer/password-viewer.component.css
// module chunks = main